import React, { useState } from 'react';
import { FiX, FiCalendar } from 'react-icons/fi';

export interface ApprovedFilterData {
  startDate: string;
  endDate: string;
}

export interface ApprovedFilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (data: ApprovedFilterData) => void;
}

export const ApprovedFilterModal: React.FC<ApprovedFilterModalProps> = ({
  isOpen,
  onClose,
  onApply,
}) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  if (!isOpen) return null;

  const handleApply = () => {
    onApply({
      startDate,
      endDate,
    });
    onClose();
  };

  const handleClear = () => {
    setStartDate('');
    setEndDate('');
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-xl w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-neutral-200">
          <h2 className="text-lg font-semibold text-neutral-900">Filtros</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-neutral-400 hover:text-neutral-600 transition-colors"
          >
            <FiX className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4">
          {/* Data inicial e Data final - Grid 2 colunas */}
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-neutral-700 mb-1">
                Data inicial
              </label>
              <div className="relative">
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => {
                    setStartDate(e.target.value);
                  }}
                  placeholder="Inserir"
                  className="w-full px-3 py-2 pr-9 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                />
                <FiCalendar className="absolute right-2.5 top-1/2 -translate-y-1/2 text-purple-600 w-4 h-4 pointer-events-none" />
              </div>
            </div>

            <div>
              <label className="block text-xs font-medium text-neutral-700 mb-1">Data final</label>
              <div className="relative">
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => {
                    setEndDate(e.target.value);
                  }}
                  placeholder="Inserir"
                  className="w-full px-3 py-2 pr-9 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                />
                <FiCalendar className="absolute right-2.5 top-1/2 -translate-y-1/2 text-purple-600 w-4 h-4 pointer-events-none" />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-2 p-4 border-t border-neutral-200">
          <button
            type="button"
            onClick={handleClear}
            className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-lg hover:bg-neutral-50 transition-colors font-medium text-sm"
          >
            Limpar filtros
          </button>
          <button
            type="button"
            onClick={handleApply}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors font-medium text-sm"
          >
            Aplicar filtros
          </button>
        </div>
      </div>
    </div>
  );
};
